import React, { FC, useState } from 'react'

import CampaignActionReportOverviewTable from './CampaignActionReportOverviewTable'
import { CampaignActionReportFilters } from './CampaignActionReportFilters'

import './CampaignActionReport.less'

export interface ICampaignActionReportFilters {
  search: string
  groupIds: number[]
  page: number
}

export const CampaignActionReport: FC = () => {
  const [filters, setFilters] = useState<ICampaignActionReportFilters>({
    page: 0,
    groupIds: [],
    search: ''
  })

  const mergeAndSetFilters = (
    newFilters: Partial<ICampaignActionReportFilters>
  ) => {
    setFilters({ ...filters, ...newFilters })
  }

  return (
    <div className="CampaignReports">
      <section className="CampaignReports__filters">
        <CampaignActionReportFilters
          filters={filters}
          onFilterChange={mergeAndSetFilters}
        />
      </section>
      <section className="CampaignReports__overview">
        <CampaignActionReportOverviewTable
          onFilterChange={mergeAndSetFilters}
          filters={filters}
        />
      </section>
    </div>
  )
}
